import axios from 'axios';

export default class InsightIndex {
  constructor(element, optionalContainer) {
    this.passedElement = element;
    this.optionalContainer = optionalContainer;
    this.maxHeight = 0;
    this.resizeTimer;
    this.init();
  }

  init = () => {
    if (!this.initialised) {
      this.initialised = true;
      this.addEventListeners();
      this.getElements();
      this.getHeightOfTallestElement();
      this.setMinHeightOnArticles();
    }
  }


  getElements = () => {
    this.articleBlocks = this.optionalContainer.querySelectorAll(".rf-article-block__inner");
  }

  getHeightOfTallestElement = () => {
    this.articleBlocks.forEach((item, i) => {
      let height = item.offsetHeight;
      this.maxHeight = (height > this.maxHeight) ? height : this.maxHeight;
    });
  }

  setMinHeightOnArticles = () => {
    this.articleBlocks.forEach((item, i) => {
      item.style.minHeight = this.maxHeight + "px";
    });
  }

  handleResize = () => {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.getHeightOfTallestElement();
      this.setMinHeightOnArticles();
    }, 250);
  }

  addEventListeners = () => {
    window.addEventListener('resize', this.handleResize);
  }

  removeEventListeners = () => {
    window.removeEventListener('resize', this.handleResize);
  }


  dismantle = () => {
    this.initialised = false;
    this.removeEventListeners();
  }

}
